var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tour',{attrs:{"name":"myTour","steps":_vm.tourSteps,"options":_vm.tourOptions,"callbacks":_vm.tourCallbacks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }